import { FtTableHeadData } from "components/common/table/FtTable";

export const headData: FtTableHeadData[] = [
  {
    id: "created",
    label: "",
    alwaysShow: true,
    width: 120,
    dynamicRender: ({ t, value }) => {
      return t(`common:date_format`, {
        value,
      });
    },
  },
  {
    id: "fileTitle",
    label: "",
    alwaysShow: true,
    width: 200,
  },
];
